import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { KeenIcon, DefaultTooltip } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { Building, Loader2 } from 'lucide-react';
const CardIntegration = ({
  icon,
  logo,
  path,
  name,
  description,
  descriptionContent,
  metadata,
  actions,
  onNameClick,
  onView,
  onSecondaryView,
  secondaryViewLabel,
  onEdit,
  onDelete,
  deleteDisabled,
  deleteTooltip,
  editFirst,
  primaryActionLabel,
  primaryActionContent,
  onPrimaryAction,
  primaryActionDisabled,
  primaryActionLoading
}) => {
  const showPrimaryAction = primaryActionLabel && onPrimaryAction;
  const deleteButton = onDelete ? (
    <button
      type="button"
      className="btn btn-danger btn-outline btn-sm"
      onClick={onDelete}
      disabled={deleteDisabled}
    >
      <KeenIcon icon="trash" />
      Delete
    </button>
  ) : null;

  return <div className="card h-full">
    <div className="card-body p-5 lg:p-7.5 flex flex-col h-full">
      <div className="flex items-center justify-between mb-3 lg:mb-5">
        <div className="flex justify-between items-center gap-2 w-full">
          {icon ? icon : logo ? (
            <img src={toAbsoluteUrl(`/media/brand-logos/${logo}`)} className="h-11 shrink-0" alt="" />
          ) : (
            <Building className='size-7.5' />
          )}
          {primaryActionContent ? primaryActionContent : showPrimaryAction && (
            <button
              type="button"
              className="btn btn-sm btn-icon btn-clear btn-light"
              onClick={onPrimaryAction}
              disabled={primaryActionDisabled || primaryActionLoading}
            >
              {primaryActionLoading ?
                <Loader2 className="h-3 w-3 animate-spin" />
                :
                <KeenIcon icon="exit-right-corner" />}
            </button>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-1 lg:gap-2.5 mb-2.5">
        {onNameClick ? <button type="button" onClick={onNameClick} className="text-start text-base font-medium text-gray-900 hover:text-primary-active">
          {name}
        </button> : path ? <Link to={`${path}`} className="text-base font-medium text-gray-900 hover:text-primary-active">
          {name}
        </Link> : <span className="text-base font-medium text-gray-900">
          {name}
        </span>}
        {descriptionContent ? descriptionContent : (
          <span className="text-2sm text-gray-700 line-clamp-3">
            <DefaultTooltip title={description} placement="top">
              {description}
            </DefaultTooltip>
          </span>
        )}
      </div>

      {metadata && (
        <div className="flex items-center flex-wrap gap-4 mt-auto !pt-4 border-t border-gray-100">
          {metadata}
        </div>
      )}
    </div>

    <div className="card-footer justify-between items-center py-3.5">
      <div className='flex items-center gap-1.5'>
        {onSecondaryView && (
          <button type="button" className="btn btn-light btn-sm" onClick={onSecondaryView}>
            <KeenIcon icon="chart-line" />
            {secondaryViewLabel || 'View Details'}
          </button>
        )}
        {editFirst && onEdit && (
          <button type="button" className="btn btn-light btn-sm" onClick={onEdit}>
            <KeenIcon icon="notepad-edit" />
            Edit
          </button>
        )}
        {onView && (
          <button type="button" className="btn btn-light btn-sm" onClick={onView}>
            <KeenIcon icon="eye" />
            View
          </button>
        )}
        {!editFirst && onEdit && (
          <button type="button" className="btn btn-light btn-sm" onClick={onEdit}>
            <KeenIcon icon="notepad-edit" />
            Edit
          </button>
        )}
        {deleteButton && (deleteDisabled && deleteTooltip ? (
          <DefaultTooltip title={deleteTooltip} placement="top">
            <span>{deleteButton}</span>
          </DefaultTooltip>
        ) : deleteButton)}
      </div>
      {actions ? <div className="flex items-center gap-2.5 text-sm">Status: {actions}</div> : <div />}
    </div>
  </div>;
};

CardIntegration.propTypes = {
  icon: PropTypes.node,
  logo: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  descriptionContent: PropTypes.node,
  metadata: PropTypes.arrayOf(PropTypes.node),
  actions: PropTypes.node,
  onNameClick: PropTypes.func,
  onView: PropTypes.func,
  onSecondaryView: PropTypes.func,
  secondaryViewLabel: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  deleteDisabled: PropTypes.bool,
  deleteTooltip: PropTypes.string,
  editFirst: PropTypes.bool,
  primaryActionLabel: PropTypes.string,
  primaryActionContent: PropTypes.node,
  onPrimaryAction: PropTypes.func,
  primaryActionDisabled: PropTypes.bool,
  primaryActionLoading: PropTypes.bool
};

export { CardIntegration };
